export const config = {
    RPC_URL: process.env.REACT_APP_RPC_URL,
    REST_URL: process.env.REACT_APP_REST_API,
    EXPLORER_URL: "https://sixscan.io",
    STAKING_URL: "https://sixscan.io",
    NETWORK_NAME: process.env.REACT_APP_CHAIN_NAME,
    NETWORK_TYPE: process.env.REACT_APP_NETWORK_TYPE,
    CHAIN_ID: process.env.REACT_APP_CHAIN_SIX_ID,
    CHAIN_NAME: process.env.REACT_APP_CHAIN_NAME,
    COIN_DENOM: "SIX",
    COIN_MINIMAL_DENOM: "usix",
    COIN_DECIMALS: 6,
    PREFIX: "6x",
    COIN_TYPE: 118,
    COINGECKO_ID: "six-network",
    DEFAULT_GAS: 200000,
    GAS_PRICE_STEP_LOW: 1.25,
    GAS_PRICE_STEP_AVERAGE: 1.45,
    GAS_PRICE_STEP_HIGH: 1.65,
    FEATURES: ["ibc-transfer", "cosmwasm", "ibc-go"],
  };
  